const routes = {
  path: '/resource-shop',
  component: () => import('@/components/layout/index.vue'),
  alwaysShow: true,
  meta: {
    title: '云门店资源',
    icon: 'icongongzuotai',
    permission: 'shop'
  },
  children: [
    {
      path: 'material-enterprise',
      name: 'MaterialEnterprise',
      component: () => import('@/views/shop/materialEnterprise.vue'),
      meta: {
        title: '文章素材',
        isUseLatest: true,
        permission: 'shop.company-article.list'
      }
    },
    {
      path: 'material-admin',
      name: 'MaterialAdmin',
      component: () => import('@/views/shop/materialAdmin.vue'),
      meta: {
        title: '经纪人素材',
        isUseLatest: true,
        permission: 'shop.private-article.list'
      }
    },
    {
      path: 'material-article',
      name: 'MaterialArticle',
      component: () => import('@/views/shop/ariticle.vue'),
      meta: {
        title: '门店文章',
        isUseLatest: true,
        permission: 'shop.article.list'
      }
    },
    {
      path: 'material-article-detail',
      name: 'ArticleDetail',
      component: () => import('@/views/shop/articleDetail.vue'),
      hidden: true,
      meta: {
        title: '文章详情',
        isUseLatest: true,
      }
    },
    {
      path: 'material-esf-list',
      name: 'ResourcEsfList',
      component: () => import('@/views/shop/esfList'),
      meta: {
        title: '门店二手房',
        permission: 'shop.company-esf.list'
      }
    },
    {
      path: 'material-esf-detail',
      name: 'ResourceEsfDetail',
      component: () => import('@/views/shop/esfDetail.vue'),
      hidden: true,
      meta: {
        title: '门店二手房详情',
        isUseLatest: true,
        permission: 'shop.company-esf.detail'
      }
    },
    {
      path: 'material-video-list',
      name: 'ResourcVideoList',
      component: () => import('@/views/shop/videoList'),
      meta: {
        title: '门店快拍',
        permission: 'shop.company-video.list'
      }
    },
    {
      path: 'material-placard-list',
      name: 'ResourcPlacardList',
      component: () => import('@/views/shop/material_placard'),
      meta: {
        title: '海报素材',
        permission: 'shop.company-placard.list'
      }
    },
  ]
}
export default routes;